import { ScrollArea } from "../components/ScrollArea";
import { Separator } from "../components/Separator";
import { cn } from "../lib/utils";
import { cva } from "class-variance-authority";
import * as React from "react";
const hoveringBarVariants = cva(cn("inline-flex items-center shadow-md backdrop-blur-sm p-1", "bg-background/80 border border-border"), {
    variants: {
        size: {
            xs: "rounded-xl",
            sm: "rounded-2xl",
        },
    },
    defaultVariants: {
        size: "xs",
    },
});
/**
 * A compact floating toolbar that groups contextual actions, typically surfaced
 * over a selection or hovered element (e.g. a rich-text formatting bar). Compose
 * it from Button children and insert HoveringBar.Separator to visually group
 * related actions. Use it for inline, contextual action clusters such as
 * text-formatting controls or selection menus.
 *
 * @summary Floating contextual action toolbar.
 */
export function HoveringBar({ children, className, size }) {
    return (React.createElement("div", { className: cn(hoveringBarVariants({ size }), className) },
        React.createElement(ScrollArea, { orientation: "horizontal", hideScrollBar: true, className: "h-full" },
            React.createElement("div", { className: "flex items-center gap-1" }, children))));
}
function HoveringBarSeparator() {
    return React.createElement(Separator, { orientation: "vertical", className: "my-1" });
}
HoveringBar.Separator = HoveringBarSeparator;
//# sourceMappingURL=HoveringBar.js.map